import { action, observable } from 'mobx';
import { RootStore } from 'stores/rootStore';
import { SingleValueResponse } from 'common/interfaces';
import { AccountDetailStore } from './account/accountDetailStore';

import {
  API_ACCOUNT_COMPLETE,
  API_ACCOUNT_COMPLETE_CHECK,
  API_ACCOUNT_DETAIL_COMPLETE,
  API_ACCOUNT_DETAIL_COMPLETE_CHECK,
} from 'api/endpoints';
import { ApiStore, ApiResponseError } from 'stores/apiStore';

interface Progress {
  percentage: number;
  //completedSteps: number;
  totalSteps: number | string;
  detail: { [key: string]: string };
}

interface Data extends Progress {
  value: 'PENDING' | 'IDLE';
}

export class AccountCompleteStore {
  rootStore: RootStore;
  apiStore: ApiStore;
  accountDetailStore: AccountDetailStore | undefined;
  accountId: string;
  detailMode: boolean;
  timerID: number;
  @observable progress: Progress;
  @observable error: ApiResponseError[] | undefined;
  @observable done: boolean;

  constructor(rootStore: RootStore, accountId: string, detailMode?: boolean, accountDetailStore?: AccountDetailStore) {
    this.rootStore = rootStore;
    this.apiStore = rootStore.stores.apiStore;
    this.accountDetailStore = accountDetailStore || undefined;
    this.accountId = accountId;
    this.progress = {
      percentage: 0,
      //completedSteps: 0,
      totalSteps: '?',
      detail: {},
    };
    this.done = false;
    this.detailMode = detailMode || false;
    this.timerID = 0;
  }

  @action
  checkProgress = async () => {
    const response = await this.apiStore.get<Data>(
      this.detailMode
        ? API_ACCOUNT_DETAIL_COMPLETE_CHECK(
            this.accountId,
            this.rootStore.stores.userStore.loggedUser!.realm.toUpperCase(),
          )
        : API_ACCOUNT_COMPLETE_CHECK(this.accountId, this.rootStore.stores.userStore.loggedUser!.realm.toUpperCase()),
    );

    if (response && (response.errors || response.data || response?.status === 500)) {
      if (response.errors || response.status === 500) {
        window.clearTimeout(this.timerID);
        this.error = response.errors;
        this.progress = response.errors ? response.errors[0].params : 0;
        if (this.detailMode) {
          this.accountDetailStore!.stopProcessing(true);
        }
        return;
      }

      // done
      if (response.data?.value === 'IDLE') {
        window.clearTimeout(this.timerID);
        this.done = true;
      } else {
        // still working
        this.progress = response.data!;
        this.timerID = window.setTimeout(this.checkProgress, 2000);
      }
    } else {
      // no response
      window.clearTimeout(this.timerID);
      this.error = [{ type: 'Error', key: 'no response', message: '' }];
      if (this.detailMode) {
        this.accountDetailStore!.stopProcessing(true);
      }
    }
  };

  // restart the process
  @action
  reinitialize = async () => {
    window.clearTimeout(this.timerID);
    this.error = undefined;
    await this.apiStore.patch<{ data: SingleValueResponse<boolean> }>(
      this.detailMode
        ? API_ACCOUNT_DETAIL_COMPLETE(this.accountId, this.accountDetailStore!.flow!.id, this.accountDetailStore!.types)
        : API_ACCOUNT_COMPLETE(this.accountId),
    );
    this.timerID = window.setTimeout(this.checkProgress, 0);
    if (this.detailMode) {
      this.accountDetailStore!.startProcessing();
    }
  };

  @action
  clearTimer = () => {
    window.clearTimeout(this.timerID);
  };
}
